import React from 'react'
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import SearchAutosuggestComponent from '../../Utility/Components/SearchAutosuggestComponent'
import { DebounceInput } from 'react-debounce-input';
import DatePicker from "@sentisso/react-modern-calendar-datepicker";
import '@sentisso/react-modern-calendar-datepicker/lib/DatePicker.css';
import OrgFilter from './OrgFilter';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Config from '../../Utility/Config';

function ChatFilterContent(props) {
    const { handleChangeOrganizationFilter, organizationFilterSelectedData, handlePriorityCheckboxChange, isPriorityChecked, handleUserSearchBar, searchValue, clearSearchValue, selectedDayRange, handleSelectedDayRange, formatInputValue, clearFromToDate, exportChatHistoryFn, userCredentials } = props;
    let version = userCredentials?.user_details?.version
    let user_role = userCredentials?.user_details?.user_type
    return (
        <>
            <div className='rightboxes fullWidth'>
                <div className="pageinnersearch chatHistory">
                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                    <DebounceInput
                        minLength={2}
                        debounceTimeout={500}
                        onChange={handleUserSearchBar.bind(this)}
                        placeholder="Search by name, phone number, chat history"
                        value={searchValue}
                    />

                    {searchValue != "" ?
                        < button type="button" className="btn btn-link dropclosebtn"
                            onClick={clearSearchValue}
                        >
                            <img src={require('../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                        </button>
                        : null}
                </div>
                <button className='exportbtn' onClick={exportChatHistoryFn} data-tip="Export"><img src={require('../../Utility/Public/images/downloadIconNew.png')} className="export_icon" /></button>
                <ReactTooltip place="bottom" />
            </div>
            {Config.includedVersion.includes(version) ?
                <>
                    {user_role == "app_admin" ?
                        < OrgFilter
                            handleChangeOrganizationFilter={handleChangeOrganizationFilter}
                            organizationFilterSelectedData={organizationFilterSelectedData}
                        /> : null}
                    {props.tabValue != -1 ?
                        <div className="inactivebox">
                            <div className="inactiveboxround">
                                <label className="custom_checkbox_container">Priority
                                    <input type="checkbox" onChange={handlePriorityCheckboxChange} checked={isPriorityChecked} />
                                    <span className="checkmarkCheckbox"></span>
                                </label>
                            </div>
                        </div> : null}

                    <div className='rightboxes'>

                        <div className="datepickerinnerbox ofdatepickerleave callbackdatepik">
                            <DatePicker
                                value={selectedDayRange}
                                onChange={handleSelectedDayRange} //setSelectedDayRange
                                formatInputText={formatInputValue} // format value
                                // inputPlaceholder={`Select Date Range(${Config.timeZone})`}
                                inputPlaceholder={`Select Date Range`}
                                inputClassName='padY border-left-0 shadow-none text-md'
                                calendarRangeBetweenClassName='bg-info text-white'
                                calendarRangeStartClassName='bg-info text-white'
                                calendarRangeEndClassName='bg-info text-white'
                            // shouldHighlightWeekends
                            />
                            {selectedDayRange.from != null && selectedDayRange.from != "" && selectedDayRange.to != null && selectedDayRange.to != "" ?
                                <button type='button' className='dateclearbutton' onClick={() => clearFromToDate()}>
                                    <img src={require('../../Utility/Public/images/dropcloseicon.png')} className="dateClearIcon" />
                                </button>
                                : null}
                        </div>
                    </div>
                </> : null
            }
        </>
    )
}
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials
    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(ChatFilterContent)));
